import React from "react";
import { ProductFormValues } from "../../../types/product/ProductFormValues";
import { useProduct } from "../../../hooks/useProduct";
import InputField from "../../Forms/Input/InputField";

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductStorageLocationSection: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">

      {/* Pasillo */}
      <InputField
        label="Pasillo"
        name="storageAisle"
        type="text"
        iconKey="box"
        value={form.storageAisle ?? ""}
        onChange={(e) => onChange("storageAisle", e.target.value)}
        placeholder="Ej: A, B, C, 01"
        error={formErrors.storageAisle}
      />

      {/* Fila */}
      <InputField
        label="Fila"
        name="storageRow"
        type="text"
        iconKey="layers"
        value={form.storageRow ?? ""}
        onChange={(e) => onChange("storageRow", e.target.value)}
        placeholder="Ej: Norte, Sur, 01"
        error={formErrors.storageRow}
      />

      {/* Estante */}
      <InputField
        label="Estante"
        name="storageShelf"
        type="text"
        iconKey="stack"
        value={form.storageShelf ?? ""}
        onChange={(e) => onChange("storageShelf", e.target.value)}
        placeholder="Ej: Superior, Medio, A"
        error={formErrors.storageShelf}
      />

      {/* Gaveta */}
      <InputField
        label="Gaveta / Bin"
        name="storageBin"
        type="text"
        iconKey="archive"
        value={form.storageBin ?? ""}
        onChange={(e) => onChange("storageBin", e.target.value)}
        placeholder="Ej: 01, Caja3, B4"
        error={formErrors.storageBin}
      />
    </div>
  );
};

export default ProductStorageLocationSection;
